<ui-detail-section
    [title]="'Für wen eignet sich das Angebot?'"
>
    @if (mapItem().humanGroupSize) {
        <ui-detail-description
            [title]="'Teilnehmeranzahl'"
            [htmlDescription]="mapItem().humanGroupSize!"
        />
    }
    @if (mapItem().groupSize) {
        <ui-detail-description
            [title]="'Gruppengröße'"
            [htmlDescription]="mapItem().groupSize!"
        />
    }
    @if (mapItem().ageGroups) {
        <ui-detail-tags
            [title]="'Alter'"
            [tags]="mapItem().ageGroups"
        />
    }
    @if (mapItem().audienceGender; as gender) {
        <ui-detail-description
            [title]="'Geschlechtsspezifisches Angebot?'"
        >
            @switch (gender) {
                @case ('male') {
                    <i class="pi pi-mars"></i>
                }
                @case ('female') {
                    <i class="pi pi-venus"></i>
                }
                @default {
                    Nein
                }
            }
        </ui-detail-description>
    }
    @if (mapItem().accessibilityFeatures; as features) {
        <ui-detail-description
            [title]="'Können besondere Unterstützungsbedarfe berücksichtigt werden (Inklusionsbedarf)?'"
            [htmlDescription]="features"
        />
    }
</ui-detail-section>
